import { Dialog, type DialogProps } from "@mui/material";
import { useIsDesktop } from '@repo/ui';
import { type FC } from "react";

const Modal: FC<DialogProps> = ({ children, onClose, ...rest }) => {
	const isDesktop = useIsDesktop();

	return (
		<Dialog onClose={onClose} fullScreen={!isDesktop} {...rest}>
			{children}
		</Dialog>
	);
};

export default Modal;
